import React from "react";
import "./contactPage.css";
import mailIcon from "../../assets/mail.svg";
import phoneIcon from "../../assets/telefon.svg";
import addressIcon from "../../assets/adres.svg";

const ContactPage = () => {
  return (
    <div className="contact-page">
      {/* Mail Bölümü */}
      <div className="contact-column">
        <img src={mailIcon} alt="Mail Icon" className="contact-icon first-col all" />
        <a href="mailto:hello@julcreative.com.tr" className="contact-link-mail">
          hello@julcreative.com.tr
        </a>
      </div>

      {/* Telefon Bölümü */}
      <div className="contact-column">
        <img src={phoneIcon} alt="Phone Icon" className="contact-icon second-col all" />
        <a href="tel:+905322166510" className="contact-link-pho">
          +90 532 216 6510
        </a>
      </div>

      {/* Adres Bölümü */}
      <div className="contact-column">
        <img src={addressIcon} alt="Address Icon" className="contact-icon last-col all" />
        <a
          href="https://www.google.com/maps?q=Acıbadem+Mahallesi+Asaf+Bey+Sk.+İmer+Apt.+No:7A+Kadıköy/İstanbul"
          target="_blank"
          rel="noopener noreferrer"
          className="contact-link-add"
        >
          Acıbadem Mahallesi Asaf Bey Sk.<br/> İmer Apt. No:7A
          <br />
          Kadıköy/İstanbul
        </a>
      </div>
    </div>
  );
};

export default ContactPage;
